import ACA from "@adactive/adsum-utils/services/ClientAPI";
import { Path } from "@adactive/adsum-web-map";
import axios from "axios";
import store from "../store";
import { esplanadeUser, esplanadePass } from "./constants";

export const getPoi = (object) => {
  if (object && object.placeId) {
    return ACA.getPoisFromPlace(object.placeId);
  }
  return null;
};

export const getPlace = (object) => {
  const poi = getPoi(object);
  if (poi && poi.length && poi.length > 0) {
    poi[0].placeId = object.placeId;
    return ACA.getPlace(object.placeId);
  }
  return null;
};

export const checkComputedPath = async (object, viaLift) => {
  const state = store.getState();
  const awm = state.app.awm;
  try {
    const place = getPlace(object);
    const locationRepo = awm ? awm.wayfindingManager.locationRepository : null;
    const path = new Path(
      locationRepo.userLocation,
      locationRepo.locations.get(place.id),
      viaLift
    );
    makeQuerablePromiseModified(awm.wayfindingManager.computePath(path));
    await awm.wayfindingManager.computePath(path);
    return true;
  } catch (e) {
    console.log("Error when computePath", e);
    return false;
  }
};

const makeQuerablePromiseModified = (promise) => {
  let errorShowedUp = false;
  const result = promise.then(
    () => {
      errorShowedUp = false;
    },
    () => {
      errorShowedUp = true;
    }
  );
  result.isFulfilled = () => !errorShowedUp;
  return result;
};

export const getGalleryPlaylist = () => {
  return Array.from(ACA.getPlaylistBy({ name: "Gallery" })[0].medias.values)
    .map((data) => ACA.getMedias([data.value])[0])
    .filter((slider) => {
      const currentDate = new Date();
      if (slider.start_at && slider.end_at) {
        return (
          currentDate >= new Date(slider.start_at) &&
          currentDate <= new Date(slider.end_at)
        );
      }
      return slider;
    })
    .map((media) => {
      const autoPlayIntervalPattern = new RegExp(/[#^[0-9]{1,2}?$/);
      const timePattern = new RegExp(/\d+/);
      let time = null;
      if (
        media &&
        media.description &&
        media.description.match(autoPlayIntervalPattern)
      ) {
        // eslint-disable-next-line prefer-destructuring
        const autoPlayInterval = media.description.match(
          autoPlayIntervalPattern
        )[0];
        if (autoPlayInterval && autoPlayInterval.match(timePattern)) {
          time = autoPlayInterval.match(timePattern) * 1000;
        }
      }
      media.interval = time;
      return media;
    });
};

export const fetchPromoData = async () => {
  const username = esplanadeUser;
  const password = esplanadePass;
  const token = `${username}:${password}`;
  const encodedToken = Buffer.from(token).toString("base64");
  const url =
    "https://wdsq-prod.myhabitap.com/api/integration/edirectory/promos/";
  const data = await axios.get(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Basic ${encodedToken}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
  console.log(data.data);
  const promo = data.data.filter((data) => {
    const now = new Date();
    return now > data.periodStart && data.periodEnd;
  });
  return promo.length > 0 && promo;
};

export const wait = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout));
};

export const getPathNameParams = () => {
  const allUrl = window.location.href;
  const splittedPath = allUrl.split("=");
  if (splittedPath && splittedPath.length && splittedPath[1]) {
    return {
      x: parseFloat(splittedPath[1].replace("&y", ""), 10),
      y: parseFloat(splittedPath[2].replace("&z", ""), 10),
      z: parseFloat(splittedPath[3].replace("&floor", ""), 10),
      floorId: parseInt(splittedPath[4], 10),
      poiId: parseInt(splittedPath[5], 10),
    };
  }
  return "/";
};
